/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.actions', [])
  /**
   * Service used to access all calls to the actions rest service.
   */
  .factory('httpActions', function ($http, BATCH_STATES) {
    /**
     * Gets the specified number of finished actions.
     * @param {Number} limit - The maximum number of finished actions to return.
     * @returns {Array} A list of actions.
     */
    var getFinishedActions = function (limit) {
      return $http({
        method: 'GET',
        url: 'api/actions/all',
        params: {
          limit: limit,
          state: BATCH_STATES.FINISHED
        }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getFinishedActions: getFinishedActions
    };
  });
